<template>
<!---->
		<div class="task-container" v-show="planList.length">
			<div class="task-title"><span class="task-title-left"></span><span class="task-title-right">学习任务</span></div>
			<div class="task-table1">
				<ul>
					<li v-for="plan in planList" :key="'HPlan' + plan.taskId">
						<a href="javascript:;" @click="toPlandetail(plan.taskId)">
							<div class="task-number">{{plan.score}}学分</div>
							<div class="task-table-title">
								<span :class="plan.typeClass">{{plan.typeStr}}</span>
								{{plan.taskName}}
							</div>
							<div class="task-time">
								有效时间：{{plan.endStr}}
							</div>
						</a>
					</li>

				</ul>
			</div>
		</div>
</template>

<script>
import '../../../assets/css/index.css'
import {ApiGetHomeTask} from '../../../net/home/index.js'
import {setCookie} from '../../../untils/common.js'
export default {
  data: function () {
    return {
      planList: []
    }
  },
  methods:{
    getHomeTask: function () {
      ApiGetHomeTask().then(res=>{
        if (res.code == 200) {
          this.planList = res.value.map(item=>{
            const typeArr = ['', '课程 ', '考试', '培训']
            return {
                ...item,
                endStr: item.isForever == 2?'永久有效':item.taskEndTime,
                typeStr: typeArr[item.taskType],
                typeClass: `task-table-label${item.taskType}`
              }
          })
          this.planList = this.planList.filter(item => {
            return item.taskType != 2
          })
        }
      })
    },
    toPlandetail: function (id){
      if(!this.$store.state.isLogin){
        this.$store.commit('showLogin', true)
        return
      }
      setCookie('frompage1','home');
      this.$router.push({
          path : 'PlanDetail',
          query : {id : id},
      })
    },
  },
  mounted: function () {
    this.getHomeTask()
  }
}
</script>

<style scoped>
.notice-box{
  margin: 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/children/plans.vue